import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, OnInit, ViewChild } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SelecaoPedidoComponent } from 'src/app/@shared/components/selecao-pedido/selecao-pedido.component';
import { PedidoConsultaOutput } from 'src/app/@shared/models/consulta-detalhe';
import { ConsultaDetalhesPorAgenciaContaInput, ConsultaDetalhesPorClienteInput, ConsultaDetalhesPorContaInput, ConsultaDetalhesPorNFeInput, ConsultaDetalhesPorNRTInput, ConsultaDetalhesPorNumeroRastreioInput } from 'src/app/@shared/models/consulta-detalhes/consulta-detalhes.model';
import { ConsultaDetalheService } from 'src/app/services/consulta-detalhe/consulta-detalhe.service';
import { RastreamentoService } from 'src/app/services/rastreamento/rastreamento.service';
import { DetalheFormularioAgenciacontaComponent } from '../detalhe-formulario-agenciaconta/detalhe-formulario-agenciaconta.component';
import { DetalheFormularioIdcontaComponent } from '../detalhe-formulario-idconta/detalhe-formulario-idconta.component';
import { DetalheFormularioNfeComponent } from '../detalhe-formulario-nfe/detalhe-formulario-nfe.component';
import { DetalheFormularioNrtComponent } from '../detalhe-formulario-nrt/detalhe-formulario-nrt.component';
import { DetalheFormularioNumerorastreioComponent } from '../detalhe-formulario-numerorastreio/detalhe-formulario-numerorastreio.component';
import { DetalheFormularioRegistroclienteComponent } from '../detalhe-formulario-registrocliente/detalhe-formulario-registrocliente.component';

@Component({
  selector: 'app-detalhe-formulario',
  templateUrl: './detalhe-formulario.component.html',
  styleUrls: ['./detalhe-formulario.component.scss']
})
export class DetalheFormularioComponent implements OnInit {
  @ViewChild('formNRT') formNRT: DetalheFormularioNrtComponent;
  @ViewChild('formAGCC') formAGCC: DetalheFormularioAgenciacontaComponent;
  @ViewChild('formIDCONTA') formIDCONTA: DetalheFormularioIdcontaComponent;
  @ViewChild('formNFE') formNFE: DetalheFormularioNfeComponent;
  @ViewChild('formNRASTREIO') formNRASTREIO: DetalheFormularioNumerorastreioComponent;
  @ViewChild('formREGISTROCLIENTE') formREGISTROCLIENTE: DetalheFormularioRegistroclienteComponent;
  clientes:any[] = [];

  public onLoadingChange: EventEmitter<Boolean> = new EventEmitter();
  public onSearchResult: EventEmitter<PedidoConsultaOutput> = new EventEmitter();

  alteraLoading(isLoading) {
    this.onLoadingChange.emit(isLoading);
  }

  async consultaPedidos(pedidos: PedidoConsultaOutput[]) {
    if (pedidos.length > 1) {
      this.abrirSelecaoPedido(pedidos);
    } else if (pedidos.length == 1) {
      let _p = await this.complementarDadosPedido(pedidos[0]);
      this.onSearchResult.emit(_p);
    } else {
      this.onSearchResult.emit(null);
      this.openSnackBar('Não foram localizados dados para os filtros informados', 'OK', 3000, 'warning-snackbar');
    }
  }

  constructor(
    public snackBar: MatSnackBar,
    private consultaDetalhesService: ConsultaDetalheService,
    private rastreamentoService: RastreamentoService,
    public selecaoPedido: MatBottomSheet
  ) { }

  ngAfterViewInit() {
    //carregar eventos de busca para envio das informaçoes para a página principal
    this.formNRT.onInput.subscribe((input: ConsultaDetalhesPorNRTInput) => this.searchByNRT(input));
    this.formAGCC.onInput.subscribe((input: ConsultaDetalhesPorAgenciaContaInput) => this.searchByAgenciaConta(input));
    this.formIDCONTA.onInput.subscribe((input: ConsultaDetalhesPorContaInput) => this.searchByConta(input));
    this.formNFE.onInput.subscribe((input: ConsultaDetalhesPorNFeInput) => this.searchByNFE(input));
    this.formNRASTREIO.onInput.subscribe((input: ConsultaDetalhesPorNumeroRastreioInput) => this.searchByNumeroRastreio(input));
    this.formREGISTROCLIENTE.onInput.subscribe((input: ConsultaDetalhesPorClienteInput) => this.searchByRegistroCliente(input));
  }

  ngOnInit() {
    //carregar combo de clientes
    this.listarClientes();
  }

  abrirSelecaoPedido(pedidos: PedidoConsultaOutput[]): void {
    this.alteraLoading(true);

    const bottomRef = this.selecaoPedido.open(SelecaoPedidoComponent, {
      data: pedidos,
      disableClose: true
    });

    bottomRef.afterDismissed().subscribe(async response => {
      if (response) {
        let _p = await this.complementarDadosPedido(response);
        this.onSearchResult.emit(_p);
      }
      this.alteraLoading(false);
    })
  }

  listarClientes() {
    this.consultaDetalhesService
      .getClientesConsultaDetalhes()
      .subscribe(response => {
        this.clientes = response;
      },
        (err: HttpErrorResponse) => {
          console.error(err);
          this.openSnackBar('Ocorreu um erro ao consultar! Tente novamente ou entre em contato com o suporte : ' + err.error.Protocolo ?? err.error.Message, 'OK', 10000, 'danger-snackbar');
        });
  }

  /* COMPLEMENTAR MODEL COM OUTRAS CONSULTAS */
  async complementarDadosPedido(pedido: PedidoConsultaOutput) : Promise<PedidoConsultaOutput> {
    await Promise.all([
      this.searchDadosGuia(pedido),
      this.searchTracking(pedido),
      this.searchRAT(pedido),
      this.searchBaixaOnline(pedido),
    ]);
    return pedido;
  }

  searchDadosGuia(pedido: PedidoConsultaOutput) {
    return this.consultaDetalhesService.getConsultaDetalhadaDadosGuia(pedido.pedidoId)
    .toPromise()
    .then(
      result => pedido.pedidoItem = result,
      (err: HttpErrorResponse) => {
        this.alteraLoading(false);
        console.error(err);
        this.openSnackBar('Ocorreu um erro ao consultar dados da guia, entre em contato com o suporte : ' + err.error.Protocolo ?? err.error.Message, 'OK', 10000, 'danger-snackbar');
      });
  }

  searchRAT(pedido: PedidoConsultaOutput) {
    return this.consultaDetalhesService.getConsultaDetalhadaDadosRAT(pedido.pedidoId)
    .toPromise()
    .then(
      result => pedido.rat = result,
      (err: HttpErrorResponse) => {
        this.alteraLoading(false);
        console.error(err);
        this.openSnackBar('Ocorreu um erro ao consultar RAT, entre em contato com o suporte : ' + err.error.Protocolo ?? err.error.Message, 'OK', 10000, 'danger-snackbar');
      });
  }

  searchBaixaOnline(pedido: PedidoConsultaOutput) {
    return this.consultaDetalhesService.getConsultaDetalhadaDadosBaixaOnline(pedido.pedidoId)
    .toPromise()
    .then(
      result => pedido.comprovantes = result,
      (err: HttpErrorResponse) => {
        this.alteraLoading(false);
        console.error(err);
        this.openSnackBar('Ocorreu um erro ao consultar comprovantes, entre em contato com o suporte : ' + err.error.Protocolo ?? err.error.Message, 'OK', 10000, 'danger-snackbar');
      });
  }

  searchTracking(pedido: PedidoConsultaOutput) {
    return this.rastreamentoService.selecionarRastreamentoPedidoTracking(pedido.pedidoId)
    .toPromise()
    .then(
      result => pedido.tracking = result,
      (err: HttpErrorResponse) => {
        this.alteraLoading(false);
        console.error(err);
        this.openSnackBar('Ocorreu um erro ao consultar rastreamento, entre em contato com o suporte : ' + err.error.Protocolo ?? err.error.Message, 'OK', 10000, 'danger-snackbar');
      });
  }

  /* EFETUAR BUSCAS */

  searchByNRT(nrtInput: any) {
    this.alteraLoading(true);
    this.consultaDetalhesService.getConsultaDetalhadaPorNRT(nrtInput.pedidoid)
    .subscribe(
      async result => {await this.consultaPedidos(result); },
      (err: HttpErrorResponse) => {
        this.alteraLoading(false);
        console.error(err);
        this.openSnackBar('Ocorreu um erro ao consultar por NRT, entre em contato com o suporte : ' + err.error.Protocolo ?? err.error.Message, 'OK', 10000, 'danger-snackbar');
      });
  }

  searchByAgenciaConta(AgCCInput: ConsultaDetalhesPorAgenciaContaInput) {
    this.alteraLoading(true);
    this.consultaDetalhesService.getConsultaDetalhadaPorAgenciaConta(AgCCInput.agencia, AgCCInput.conta, AgCCInput.clienteId)
    .subscribe(
      async result => {await this.consultaPedidos(result); },
      (err: HttpErrorResponse) => {
        this.alteraLoading(false);
        console.error(err);
        this.openSnackBar('Ocorreu um erro ao consultar por Agencia e Conta, entre em contato com o suporte : ' + err.error.Protocolo ?? err.error.Message, 'OK', 10000, 'danger-snackbar');
      });
  }

  searchByNFE(NFEInput: ConsultaDetalhesPorNFeInput) {
    this.alteraLoading(true);
    this.consultaDetalhesService.getConsultaDetalhadaPorNFE(NFEInput.nfe, NFEInput.clienteId)
    .subscribe(
      async result => {await this.consultaPedidos(result); },
      (err: HttpErrorResponse) => {
        this.alteraLoading(false);
        console.error(err);
        this.openSnackBar('Ocorreu um erro ao consultar por NF-e, entre em contato com o suporte : ' + err.error.Protocolo ?? err.error.Message, 'OK', 10000, 'danger-snackbar');
      });
  }

  searchByConta(IdContaInput: ConsultaDetalhesPorContaInput) {
    this.alteraLoading(true);
    this.consultaDetalhesService.getConsultaDetalhadaPorConta(IdContaInput.idConta, IdContaInput.clienteId)
    .subscribe(
      async result => {await this.consultaPedidos(result); },
      (err: HttpErrorResponse) => {
        this.alteraLoading(false);
        console.error(err);
        this.openSnackBar('Ocorreu um erro ao consultar por Id Conta, entre em contato com o suporte : ' + err.error.Protocolo ?? err.error.Message, 'OK', 10000, 'danger-snackbar');
      });
  }

  searchByNumeroRastreio(RastreioInput: ConsultaDetalhesPorNumeroRastreioInput) {
    this.alteraLoading(true);
    this.consultaDetalhesService.getConsultaDetalhadaPorNumeroRastreio(RastreioInput.idconta, RastreioInput.clienteId)
    .subscribe(
      async result => {await this.consultaPedidos(result); },
      (err: HttpErrorResponse) => {
        this.alteraLoading(false);
        console.error(err);
        this.openSnackBar('Ocorreu um erro ao consultar por Número de Rastreio, entre em contato com o suporte : ' + err.error.Protocolo ?? err.error.Message, 'OK', 10000, 'danger-snackbar');
      });
  }

  searchByRegistroCliente(RegistroClienteInput: ConsultaDetalhesPorClienteInput) {
    this.alteraLoading(true);
    this.consultaDetalhesService.getConsultaDetalhadaPorCliente(RegistroClienteInput.codigoDeBarras, RegistroClienteInput.clienteId)
    .subscribe(
      async result => {await this.consultaPedidos(result); },
      (err: HttpErrorResponse) => {
        this.alteraLoading(false);
        console.error(err);
        this.openSnackBar('Ocorreu um erro ao consultar por Registro do Cliente, entre em contato com o suporte : ' + err.error.Protocolo ?? err.error.Message, 'OK', 10000, 'danger-snackbar');
      });
  }

  openSnackBar(message: string, action: string, duration: number, panelClass?: string): any {
    this.snackBar.open(message, action, { duration, panelClass });
  }
}
